<template>
  <v-sheet
    class="pa-2"
  >
    <v-layout wrap> <!-- Start Layout -->
      <v-flex xs12>
        <v-layout>
          <v-flex>
            <h2>{{ event.name }}</h2>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex xs12 mb-1>
        <v-divider />
      </v-flex>
      <v-flex xs12 sm6>
        <v-layout column><!-- Start Col 1 -->
          <v-flex xs12>
            <p> {{ event.desc }}</p>
          </v-flex>
          <v-flex xs12 mb-2>
            <v-layout>
              <v-flex shrink px-1>
                <v-btn flat icon :href="mapSrc" target="_blank">
                  <v-icon>
                    place
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex>
                <h3>Location</h3>
                <address>
                  {{ rink.name }}<br>
                  {{ rink.address }}<br>
                  {{ rink.city }} {{ rink.state }}, {{ rink.zip }}<br>
                </address>
              </v-flex>
              <v-spacer />
            </v-layout>
          </v-flex>
          <v-flex xs12 mb-2>
            <v-layout>
              <v-flex shrink px-1>
                <v-btn flat icon>
                  <v-icon>
                    schedule
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex>
                <h3>Schedule</h3>
                <div>
                  <em>Event Begins:</em> {{ eventDatetime }}<br>
                </div>
              </v-flex>
              <v-spacer />
            </v-layout>
          </v-flex>
          <v-flex v-show="hasSessions" xs12 pl-4>
            <h4>Sessions</h4>
          </v-flex>
          <v-flex xs12 pl-4>
            <v-layout
              row
              wrap
              v-for="session in event.sessions"
              :key="session.id"
              class="mb-1"
            >
              <v-flex xs4 sm3 md3>
                {{ viewDate(session.date, true) }}
              </v-flex>
              <v-flex xs8 sm3 md3>
                {{ viewTime(session.start) }} - {{ viewTime(session.end) }}
              </v-flex>
              <v-spacer />
              <v-flex xs12>
                {{ session.notes }}
              </v-flex>
              <v-flex xs12>
              <v-divider dark />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout><!-- End Col 1 -->
      </v-flex>
    </v-layout><!-- end layout -->
    <v-layout row pa-2>
      <v-flex xs6 sm3 md1>
      </v-flex>
      <v-spacer />
    </v-layout>
  </v-sheet>
</template>

<script>
import * as date from '../../libs/js/dates'

export default {
  name: 'EventDetail',
  props: {
    event: Object,
    rink: Object
  },
  computed: {
    mapSrc() {
      let url = ''
      if(this.rink && this.rink.id) {
        // Detect if on mobile device -- if so, use Map App URL Scheme
        if((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
          url = 'geo:' + this.rink.latitude + ', ' + this.rink.longitude
        } else {
          url = 'https://maps.google.com/?q=' + this.rink.name.replace(' ', '+') + '+' +
            this.rink.address.replace(' ', '+') + '+' +
            this.rink.city.replace(' ', '+') + '+' +
            this.rink.state.replace(' ', '+') + '+' +
            this.rink.zip.replace(' ', '+') + ''
        }
      }
      return url
    },
    hasSessions () {
      return Array.isArray(this.event.sessions) && this.event.sessions.length > 0
    },
    bdateMin () {
      return date.viewDate(this.event['bdate-min'] || this.event['nhl-bdate-min'], this.$i18n.locale)
    },
    bdateMax () {
      return date.viewDate(this.event['bdate-max'] || this.event['nhl-bdate-max'], this.$i18n.locale)
    },
    ageRestriction () {
      return this.$t('eventCard.bdateRestriction').replace('%1', this.bdateMin).replace('%2', this.bdateMax)
    },
    eventDatetime () {
      return date.viewDatetime(this.event['event-datetime'], this.$i18n.locale, this.rink.time_zone)
    },
    viewDate () {
      return (val, short) => date.viewDate(val, this.$i18n.locale, short)
    },
    viewDatetime () {
      return (val) => date.viewDatetime(val, this.$i18n.locale, this.rink.time_zone)
    },
    viewTime () {
      return (val) => date.viewTime(val, this.$i18n.locale, this.rink.time_zone)
    },
    startDate () {
      return this.event['event-datetime'].split(' ')[0]
    },
    endDate () {
      if (this.hasSessions) {
        return this.event.sessions[this.event.sessions.length - 1].date
      } else {
        return this.event['event-datetime'].split(' ')[0]
      }
    },
    sessionsByDate () {
      if (this.hasSessions) {
        let s = {}
        this.event.sessions.forEach( ses => {
          s[ses.date] = ses
        })
        return s
      } else {
        return {}
      }
    }
  }
}
</script>

<style scoped>

</style>